const fonts = {
  heading: 'Playfair Display',
  body: 'Avenir',
  header: 'Playfair Display',
};

export default fonts;
